export type LayersKeys = 'minimal' | 'sidebar' | 'header' | 'slider' | 'modal';

export const layers = {
  minimal: 1,
  header: 6,
  sidebar: 1000,
  slider: 10001,
  modal: 10002,
};
